// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"b6638155","129":"ce32a379","237":"b174a9c0","555":"f47db27e","569":"3dc609cd","678":"7cd8f21f","844":"6bd06a1b","852":"db3b2a85","971":"71b421b0"}[chunkId] + ".chunk.js";
};